/**
 * Polished, reusable sign-in CTA shown across AutoCaptions when an
 * anonymous user lands on an authed-only page (History, Brand Kit, etc).
 */
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { LogIn, Sparkles, ArrowRight } from "lucide-react";

export default function SignInRequiredCard({
  icon = <LogIn size={26} strokeWidth={1.6}/>,
  eyebrow = "Sign in required",
  title = "Sign in to continue",
  description = "Create a free MarkeeMix account to unlock this feature.",
  benefits = [],
  testId = "sign-in-required",
}) {
  const navigate = useNavigate();
  return (
    <motion.div
      className="ac-signin-card"
      data-testid={testId}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="ac-signin-icon">{icon}</div>
      <span className="ac-signin-eyebrow">
        <Sparkles size={12}/> {eyebrow}
      </span>
      <h2 className="ac-signin-title">{title}</h2>
      <p className="ac-signin-desc">{description}</p>

      {benefits.length > 0 && (
        <ul className="ac-signin-benefits">
          {benefits.map((b, i) => (
            <li key={i}>
              <span className="ac-signin-tick">✓</span> {b}
            </li>
          ))}
        </ul>
      )}

      <div className="ac-signin-actions">
        <button
          type="button"
          className="ac-btn ac-signin-primary"
          onClick={() => navigate("/login?redirect=" + encodeURIComponent(window.location.pathname + window.location.search))}
          data-testid={`${testId}-signin`}
        >
          <LogIn size={14}/> Sign in
        </button>
        <button
          type="button"
          className="ac-btn ac-btn--ghost"
          onClick={() => navigate("/register?redirect=" + encodeURIComponent(window.location.pathname + window.location.search))}
          data-testid={`${testId}-signup`}
        >
          Create free account <ArrowRight size={14}/>
        </button>
      </div>

      <p className="ac-signin-footnote">
        Free plan · no credit card · cancel anytime.
      </p>
    </motion.div>
  );
}
